import React, {FC} from 'react';
import Logo from "../components/Logo";
import apple from '../assets/images/AppButton.png';
import AppleBtn from "../components/AppleBtn";


interface Props {
}

const HomePage: FC<Props> = () => {
  return (
    <div className="wrapper">
      <div className="home_page container">
        <div className="header">
          <div className="home_page-logo">
            <Logo />
          </div>
        </div>
        <h1 className='mb-4'>Attitune</h1>
        <div className="d-flex justify-content-center">
          <AppleBtn />
        </div>
        <div className="text-center mt-4">
          <div>Contact us:</div>
          <div>
            <a href="mailto:support@attitune.us">support@attitune.us</a>
          </div>
          <div>
            <a href="mailto:sm@attitune.us">sm@attitune.us</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;